import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import tableState from "./state";
export const useSetTableErrors = (val, error, machineName, rowIndex, columnId) => {
  const setErrors = useSetRecoilState(tableState);

  useEffect(() => {
    let newTableErrors;
    if (error) {
      setErrors((errors) => {
        newTableErrors = JSON.parse(JSON.stringify(errors));
        !(machineName in newTableErrors) && (newTableErrors[`${machineName}`] = {});
        // rowKey exists? if not create it
        !(rowIndex in newTableErrors[`${machineName}`]) && (newTableErrors[`${machineName}`][`${rowIndex}`] = []);
        // item in array exists? if not push it
        !newTableErrors[`${machineName}`][`${rowIndex}`].includes(columnId) &&
          newTableErrors[`${machineName}`][`${rowIndex}`].push(columnId);
        return newTableErrors;
      });
    } else {
      if (val) {
        setErrors((errors) => {
          newTableErrors = JSON.parse(JSON.stringify(errors));
          let rowArray = errors?.[`${machineName}`]?.[`${rowIndex}`]
            ? [...errors?.[`${machineName}`]?.[`${rowIndex}`]]
            : null;

          if (rowArray) {
            let newRowArray = rowArray.filter((error) => error !== columnId);
            newTableErrors[`${machineName}`][`${rowIndex}`] = newRowArray;
          }

          return newTableErrors;
        });
      }
    }
  }, [error]);
};
